import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FaReact } from 'react-icons/fa';
import { FaGitAlt } from 'react-icons/fa6';
import { FaHtml5 } from 'react-icons/fa6';
import { IoLogoJavascript } from 'react-icons/io5';
import gym from '../img/gym.jpg';
import construccion from '../img/Construccion.jpg';
import Digitality from '../img/Digitality.png'
import { FaGithub } from 'react-icons/fa'
import { FaLaravel } from 'react-icons/fa';
import { FaBootstrap } from 'react-icons/fa';
import { DiScrum } from 'react-icons/di';

export const Projects = () => {
    var settings = {
        dots: true,
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
    // w-11/12 hidden md:block md:w-9/12 xl:w-[3400px]
    return (
        <section id='projects' className='text-white py-10 flex flex-col justify-center items-center' >

            <h2 className='text-3xl font-semibold text-green-800 mb-3 text-center'>PROJECTS</h2>

            <div className='flex flex-col gap-4 w-[90%]'>

                <article className='bg-color-dark grid grid-cols-1 lg:grid-cols-12'>
                    <div className='w-full md:col-start-1 md:col-end-6 max-h-[80%}'>
                        <img src={Digitality} className='w-72 md:w-full mx-auto' alt="construccion img" />
                    </div>
                    <div className='flex flex-col justify-between lg:col-start-6 lg:col-end-13 gap-6 p-4'>
                        <div className='flex flex-col gap-1'>
                            <h3 className='text-lg md:text-xl lg:2xl flex  sm:items-center gap-0 sm:gap-2'>
                                <span className='text-red-600 ps-2 hidden md:block'>{'<h3>'}</span>
                                <span className='md:m-2 sm:ms-0 text:lg font-semibold'>Housing association management system</span>
                                <span className='text-red-600 hidden md:block'>{'</h3>'}</span>
                            </h3>
                            <p className="text-gray-300 text-md flex  sm:items-center gap-0 sm:gap-2">
                                <span className='text-red-600 ps-2 hidden md:block'>{'<h4>'}</span>
                                <strong className='md:m-2 sm:ms-0'>Full stack developer</strong>
                                <span className='text-red-600 ps-2 hidden md:block'>{'</h4>'}</span>
                            </p>
                            <p className="text-gray-300 flex flex-wrap md:text-md">
                                <span className='text-red-600 ps-2 hidden md:block'>{'<p>'}</span>
                                <span>
                                    The system allows members to register work hours, upload payment receipts, and track their housing assignments,
                                    while administrators can approve registrations, validate payments, manage assemblies,
                                    The platform runs on Rocky Linux servers and features separate interfaces for members and administrators.
                                </span>

                                <span className='text-red-600 ps-2 hidden md:block'>{'</p>'}</span>
                            </p>

                        </div>
                        <div className='flex flex-row flex-wrap justify-between'>
                            <div className='flex flex-wrap gap-4 ms-2'>
                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <FaLaravel className='text-red-600 text-xl' />
                                    <p>Laravel</p>
                                </span>

                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <FaBootstrap className='text-purple-500 text-xl' />
                                    <p>Bootstrap</p>
                                </span>
                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <IoLogoJavascript className='text-yellow-300 text-xl' />
                                    <p>JavaScript</p>
                                </span>

                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <DiScrum className='text-orange-400 text-xl' />
                                    <p>Scrum</p>
                                </span>
                                <p></p>
                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <FaHtml5 className='text-orange-700 text-xl' />
                                    <p>Html5</p>
                                </span>
                                <p></p>
                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <FaGitAlt className='text-red-600 text-xl' />
                                    <p>Git</p>
                                </span>

                            </div>
                            <a href="https://github.com/orgs/DigitalityUTU/repositories">
                                <FaGithub className='hover:text-blue-700 text-xl' />
                            </a>
                        </div>
                    </div>
                </article>

                <article className='bg-color-dark grid grid-cols-1 lg:grid-cols-12'>
                    <div className='w-full md:col-start-1 lg:col-end-6 object-fill'>
                        <img src={gym} className='w-72 lg:w-full object-fill' alt="gym img" />
                    </div>
                    <div className='flex flex-col justify-between lg:col-start-6 lg:col-end-13 gap-6 p-4'>
                        <div className='flex flex-col gap-1'>
                            <h3 className='text-lg md:text-xl lg:2xl flex sm:items-center gap-0 sm:gap-2'>
                                <span className='text-red-600 ps-2 hidden md:block'>{'<h3>'}</span>
                                <span className='md:m-2 sm:ms-0 text:lg font-semibold'>Gym Management System</span>
                                <span className='text-red-600 ps-2 hidden md:block'>{'</h3>'}</span>
                            </h3>
                            <p className="text-gray-300 text-sm sm:text-base flex sm:items-center gap-0 sm:gap-2">
                                <span className='text-red-600 ps-2 hidden md:block'>{'<h4>'}</span>
                                <strong className='md:m-2 sm:ms-0'>Frontend Developer </strong>
                                <span className='text-red-600 ps-2 hidden md:block'>{'</h4>'}</span>
                            </p>
                            <p className="text-gray-300 md:text-md flex flex-row flex-wrap gap-2">
                                <span className='text-red-600 ps-2 hidden md:block min-w-4'>{'<p>'}</span>

                                React-based application for gym management.
                                Developed a system to store routines and exercises with live data visualization using interactive charts and graphs.

                                <span className='text-red-600 ps-2 hidden md:block min-w-4'>{'</p>'}</span>
                            </p>
                        </div>
                        <div className='flex flex-row flex-wrap justify-between items-center'>
                            <div className='flex flex-wrap gap-4'>
                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <FaReact className=' text-blue-500 text-xl' />
                                    <p>React</p>
                                </span>
                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <FaGitAlt className='text-red-600 text-xl' />
                                    <p>Git</p>
                                </span>
                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark px-3 py-2">
                                    <FaHtml5 className='text-orange-700 text-xl' />
                                    <p>Html5</p>
                                </span>
                                <span className="flex justify-between items-center gap-[14px] bg-color-ligth-dark  px-3 py-2">
                                    <IoLogoJavascript className='text-yellow-300 text-xl' />
                                    <p>JavaScript</p>
                                </span>
                            </div>
                            <a href="https://github.com/orgs/DigitalityUTU/repositories">
                                <FaGithub className='hover:text-blue-700 text-2xl' />
                            </a>
                        </div>
                    </div>
                </article>

            </div >

        </section >
    )
}

export default Projects